import { ApiClientService, EntityApiService } from '@dfl/react-security';
import { IReportStockActivity } from '../interfaces/IReportStockActivity';

class ProductStockActivityService extends EntityApiService<IReportStockActivity> {
  searchStockActivity = (productId: string, params?: any, config?: any): any => {
    if (productId) {
      return this.handleSearchResponse(
        ApiClientService.post(
          this.getPath(`/${productId}/stock-activity/search`),
          { ...params, populate: true },
          config,
        ),
        10,
      );
    }
    throw new Error('You must need a productId');
  };

  getStockActivity = (productId: string, stockId: string): Promise<any> => {
    return ApiClientService.get(this.getPath(`/${productId}/stock-activity/${stockId}`));
  };

  updateNote = (productId: string, stockId: string, note: string): Promise<any> => {
    return ApiClientService.patch(this.getPath(`/${productId}/stock-activity/${stockId}`), { note });
  };
}

export default new ProductStockActivityService('/ms-inventory/api/products');
